import styled, { css } from 'styled-components';

const baseStyle = css`
    margin: 0;
    padding: 0;
`;

const Option = styled.li`
    ${baseStyle};
    margin-bottom: 10px;
`;

const List = styled.ul`
    ${baseStyle};
    display: flex;
    flex-direction: column;
    list-style: none;
    
    ${Option}:last-child {
        margin-bottom: 0;
    }
`;

export {
    List,
    Option,
};
